import { addIcons } from "oh-vue-icons";
import { ref, h } from "vue";
import { Menu } from 'ant-design-vue';
import { CoNewspaper, CoHome, CoUser } from "oh-vue-icons/icons"; 
import { itemClient } from './menu_client';
import { itemSystemBase } from './menu_system_base';
import { itemSeller } from './menu_seller'
import { itemCoordination } from './menu_coordination'
import { itemConstruccion } from './menu_construccion'

const arrayIcons = ref([CoNewspaper, CoHome, CoUser]); 
const myMenu = ref({});

const iconsLoader = () => {
    addIcons(...arrayIcons.value); 
};
const constructMenu = (route) => {
    console.log(route)
    let typeRoute = (route.meta.mySystem.type_route != undefined) ? route.meta.mySystem.type_route : "Cliente";
    switch (typeRoute) {
        case 'Construccion':
            Object.assign(myMenu.value, convertirMenu(itemConstruccion));
            break;
        default:
            if (route.meta.layout != 'system') {
                Object.assign(myMenu.value, convertirMenu(itemClient));
            }
    }
    iconsLoader()
}
const convertirMenu = (items) => {
    const menuItems = [];
    const padres = {};
  
    // Primero, procesar los padres
    for (const key in items) {
        if (items[key].type === 'parent') {
            padres[key] = items[key];
            const defaultValuePadre = ref({ title: () => items[key].label, default: () => [] });
            menuItems.push(h(Menu.SubMenu, 
                { 
                    key: items[key].key 
                }, 
                defaultValuePadre.value
            ));
        }
    }
  
    // Luego, procesar los hijos
    for (const key in items) {
        if (items[key].type === 'item') {
            // Verificar si items[key] tiene la clave 'parent'
            if (items[key].hasOwnProperty('parent')) {
                const padre = padres[items[key].parent];
                if (padre) {
                    const padreKey = padre.key;
                    // Encontrar el padre en menuItems y agregar el hijo
                    const padreMenuItem = menuItems.find(myItem => myItem.props.key === padreKey);
                    if (padreMenuItem) {
                        if (padreMenuItem.children && padreMenuItem.children.default) {
                            if (Array.isArray(padreMenuItem.children.default())) {
                                const hijoKey = `${padreKey}-${items[key].key}`; // Crear clave única
                                const hijo = createMenuItem(hijoKey, items[key])
                                padreMenuItem.children.default().push(hijo);
                            } else {
                                console.error("padreMenuItem.children.default() no es un array");
                            }
                        } else {
                          console.error("padreMenuItem.children o padreMenuItem.children.default son undefined");
                        }
                    } else {
                        console.error("No se encontró padreMenuItem con key:", padreKey);
                    }
                }
            } else {
                // En caso de que no tenga padre.
                menuItems.push(createMenuItem(items[key].key, items[key]))
            }
        }
    }
    // // Ordenar los hijos dentro de cada SubMenu y luego el menuItems
    // menuItems.forEach((item) => {
    //     if (item.type === Menu.SubMenu) {
    //         if (item.children.default) {
    //             item.children.default().sort((a, b) => {
    //                 return b.props.key - a.props.key;
    //             });
    //         }
    //     }
    // });

    const t = menuItems.sort((a, b) => {
        return a.props.key - b.props.key;
    });

    console.log(t);
    return menuItems;
}
const createMenuItem = (key, items) => {
    console.log(items.label)
    let props = { 
        default: () => items.label,
    }
    return h(
        Menu.Item, 
        { key: key, title: items.label }, 
        props
    )
}
export { arrayIcons, myMenu, iconsLoader, constructMenu, convertirMenu };